import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";


import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';



import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Support() {
    const location = useLocation();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const lang = useSelector(state => state.langReducer.lang);

    const [supBtnHover, setSupBtnHover] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {

    }, []);

    useEffect(() => {
        const storedRegiSuc = localStorage.getItem('inqSuc');
        if (storedRegiSuc === '1') {
            const toastId = toast(lang === 0 ? '문의내용이 전송되었습니다' : 'Inquiries have been sent.');
            setTimeout(() => {
                toast.dismiss(toastId);
                localStorage.removeItem('inqSuc');
            }, 2000);
        }
    }, []);


    return (
        <>
            <div className="main_back">
                <div className="main_part padding sup">
                    <div className="title_box sup">
                        {lang === 0 ?
                            <>
                                UModeler X 학습 및 지원
                            </>
                            :
                            <>
                                UModeler X Resources
                            </>
                        }
                    </div>

                    <div className="main_support_box_title">
                        <div className="title_box">
                            {lang === 0 ?
                                <>
                                    <p>사용법 및 테크닉 배우기</p>
                                    <span>UModeler X의 기초부터 고급 기능까지 단계적으로 다룰 수 있도록 강의와 매뉴얼을 참고하세요.</span>
                                </>
                                :
                                <>
                                    <p>Learn How to Use UModeler X</p>
                                    <span>Check out the tutorials and manuals to learn UModeler X step by step.</span>
                                </>
                            }
                        </div>
                        <img src={require("../../assets/icon/sup_title_icon1.svg").default} />
                    </div>

                    <div className="support_box_manual">
                        <div
                            className="manual_box"
                            onClick={() => {
                                window.open('https://www.youtube.com/watch?v=SvtFTNtSVZI');
                            }}
                        >
                            <img src={images.sup_01} style={{objectFit: 'contain'}} />

                            <div className="comment">
                                {lang === 0 ? 'UModeler X 입문 가이드' : 'UModeler X Beginner Guide'}
                            </div>
                        </div>

                        <div
                            className="manual_box"
                            onClick={() => {
                                if (lang === 0) {
                                    window.open('https://docs.umodeler.com/ko/docs/intro');
                                } else {
                                    window.open('https://docs.umodeler.com/docs/intro');
                                }
                            }}
                        >
                            <img src={images.sup_02} style={{objectFit: 'contain'}} />

                            <div className="comment">
                                {lang === 0 ? 'UModeler X 공식 매뉴얼' : 'UModeler X Official Manual'}
                            </div>
                        </div>

                        <div
                            className="manual_box"
                            onClick={() => {
                                window.open('https://learn.unity.com/tutorial/get-started-with-umodeler-x')
                            }}
                        >
                            <img src={images.sup_03} style={{objectFit: 'contain'}} />

                            <div className="comment">
                                {lang === 0 ? '유니티 공식 UModeler X 가이드' : 'UModeler X Unity Learn'}
                            </div>
                        </div>

                        <div
                            className="manual_box"
                            onClick={() => {
                                window.open('https://youtu.be/NMYy8VcstUI?si=t1TE6jKUfKCaKdpA')
                            }}
                        >
                            <img src={images.sup_04} style={{objectFit: 'contain'}} />

                            <div className="comment">
                                {lang === 0 ? 'UModeler X 신티 스튜디오 가이드' : 'UModeler X Synty Studios Guide'}
                            </div>
                        </div>
                    </div>

                    <div className="title_box sup">
                        {lang === 0 ?
                            <>
                                다른 이용자들과 만나볼까요?
                            </>
                            :
                            <>
                                Want to connect with other users?
                            </>
                        }
                    </div>

                    <div className="support_box_manual sns">
                        <div
                            className="sns_box"
                            onClick={() => {
                                window.open('https://discord.gg/qv54qkPdgy');
                            }}
                        >
                            <img src={require("../../assets/icon/sup_sns_logo1.svg").default} />
                            <p className="title">
                                {lang === 0 ? '공식 디스코드' : 'Official Discord'}
                            </p>
                            <span className="sub_title">
                                {lang === 0 ?
                                    <>
                                        나와 같은 사람들과 만나<br />실시간으로 정보를 교류하세요.
                                    </>
                                    :
                                    <>
                                        Connect with people and share information in real time
                                    </>
                                }
                            </span>
                        </div>

                        <div
                            className="sns_box"
                            onClick={() => {
                                window.open('https://www.youtube.com/@UModeler')
                            }}
                        >
                            <img src={require("../../assets/icon/sup_sns_logo2.svg").default} />
                            <p className="title">
                                {lang === 0 ? '공식 유튜브' : 'Official Youtube'}
                            </p>
                            <span className="sub_title">
                                {lang === 0 ?
                                    <>
                                        UModeler 공식 강의를 통해<br />더 많은 것을 알아봐요.
                                    </>
                                    :
                                    <>
                                        Learn more through UModeler’s official tutorials.
                                    </>
                                }
                            </span>
                        </div>
                    </div>

                    <div className="main_support_box_title sub">
                        <div className="title_box">
                            {lang === 0 ?
                                <>
                                    <p>도움이 필요하신가요?</p>
                                    <span>보내주신 문의사항은 빠른 시일내에 확인 후 답변드리겠습니다.</span>
                                </>
                                :
                                <>
                                    <p>Need Help?</p>
                                    <span>We will review your inquiry and respond as soon as possible.</span>
                                </>
                            }

                            <button
                                type="button"
                                className="custom_btn"
                                onClick={() => {
                                    navigate(routes.Inquiry);
                                }}
                            >
                                {lang === 0 ? '문의하기' : 'Contact'}
                            </button>
                        </div>
                        <img src={require("../../assets/icon/sup_title_icon2.svg").default} />
                    </div>
                </div>

                <div className="support_history_box">
                    <div className="support_box_manual history">
                        <p className="title">
                            {lang === 0 ?
                                    <>
                                        이것도 한 번 확인해 보세요!
                                    </>
                                    :
                                    <>
                                        Explore more!
                                    </>
                                }
                            
                        </p>

                        <div
                            className="history_box"
                            onClick={() => {
                                window.open('https://discussions.unity.com/t/released-umodeler-x-model-rig-paint-and-ai-texture-within-unity-unity-vsp/659243');
                            }}
                        >
                            <img src={require("../../assets/icon/sup_history_logo1.svg").default} />
                            <p className="title">
                                Unity Discussions
                            </p>
                            <span className="sub_title">
                                {lang === 0 ?
                                    <>
                                        UModeler X Pro의<br />서비스에 대해 궁금한 점이 있나요?
                                    </>
                                    :
                                    <>
                                        Have questions about UModeler X Pro’s services?
                                    </>
                                }
                            </span>
                        </div>

                        <div
                            className="history_box"
                            onClick={() => {
                                if (lang === 0) {
                                    window.open('https://docs.umodeler.com/ko/blog/');
                                } else {
                                    window.open('https://docs.umodeler.com/blog');
                                }
                            }}
                        >
                            <img src={require("../../assets/icon/sup_history_logo2.svg").default} />
                            <p className="title">
                                {lang === 0 ? '공식 블로그' : 'Official Blog'}
                            </p>
                            <span className="sub_title">
                                {lang === 0 ?
                                    <>
                                        UModeler의 역사와<br />최신 소식에 대해 알고 싶으신가요?
                                    </>
                                    :
                                    <>
                                        Want to learn about UModeler’s history and latest updates?
                                    </>
                                }
                            </span>
                        </div>
                    </div>
                </div>

            </div> {/* 메인 div */}

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}
